import type { ResolveTbaBookRequest } from "@book-club/shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { booksKeys } from "@/features/books/queries/booksQueryKeys";
import booksService from "@/features/books/services/booksService";
import { sessionsKeys } from "@/features/sessions/queries/sessionsQueryKeys";

export function useResolveTbaBook() {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async (input: ResolveTbaBookRequest) => {
            return await booksService.resolveTbaBook(input);
        },
        onError: (error) => {
            const errorMessage = error instanceof Error ? error.message : "Failed to resolve book";
            toast.error(errorMessage);
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: booksKeys.all });
            queryClient.invalidateQueries({ queryKey: booksKeys.detail(variables.bookId) });
            queryClient.invalidateQueries({ queryKey: sessionsKeys.all });
            toast.success("Book resolved successfully");
        },
    });

    return {
        error: mutation.error,
        isError: mutation.isError,
        isPending: mutation.isPending,
        mutate: mutation.mutate,
    };
}
